import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';

// Import custom modules
import useAuth from '../../hooks/useAuth/useAuth';

const RequireAuth = () => {
  const { auth } = useAuth();
  const location = useLocation();

  return auth?.access_token ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
